import React from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import EpdRoutes from 'routes/EpdRoutes';
import AuthStatusPage from 'components/auth/AuthStatusPage';
import { HyperLink } from 'styles/Styles.styled';

const ResetPasswordTokenError: React.FC<RouteComponentProps> = () => {
  return (
    <AuthStatusPage
      imageType="error"
      imageAlt="Error"
      title="This password reset link is no longer valid"
      message={`It may have expired or already been used.\nPlease request a new reset link using the "Forgot password?" option on the Login page.`}
      link={
        <HyperLink as={Link} to={EpdRoutes.login}>
          Back to login page
        </HyperLink>
      }
    />
  );
};

export default ResetPasswordTokenError;
